module.exports = __webpack_public_path__ + "img/resized-20160702-153939.d296c714.jpg";